module.exports = {
	"nav_menu": {
		"settings": "SETTINGS",
		"manageAdmins": "MANAGE ADMINS",
		"filter_candidates": "FILTER CANDIDATES",
		"user_settings_submenu": {
			"change_password": "CHANGE PASSWORD",
			"logout": "LOGOUT"
		}
	},
	"login": {
		"email": "REGISTERED EMAIL ID",
		"password": "PASSWORD",
		"login": "Login",
		"forgotPassword": "FORGOT PASSWORD?",
		"proceed": "PROCEED"
	},
	"dashboard": {
		"onboarding": "ONBOARDING",
		"candidates": "CANDIDATES",
		"entities": "ENTITIES",
		"registered": "REGISTERED",
		"add": "ADD",
		"recently_onboarded": "RECENTLY ONBOARDED",
		"time_periods": {
			"last_week": "LAST WEEK",
			"last_month": "LAST MONTH"
		}
	},
	"onboard": {
		"onboard": "ONBOARD",
		"onboarding": "ONBOARDING",
		"name": "NAME",
		"id": "ID",
		"location": "LOCATION",
		"create_login": "CREATE LOGIN",
		"login_name": "NAME",
		"login_email": "EMAIL ID",
		"email": "EMAIL",
		"create": "CREATE",
		"login_created": "Login Created",
		"back_to_dashboard": "BACK TO DASHBOARD",
		"successfully_added": "SUCCESSFULLY ADDED",
		"academy": {
			"academy": "ACADEMY",
			"assessments": "ASSESSMENTS",
			"purchased": "PURCHASED"
		},
		"company": {
			"company": "COMPANY"
		},
		"ats": {
			"ats": "ATS",
			"notification_url": "NOTIFICATION URL"
		},
		"errors": {
			"name": "name should contain atleast 3 letters",
			"email": "please enter valid email",
			"notification_url": "please enter valid url",
			"assessments_purchased": "select any value"
		}
	},
	"candidates": {
		"skill_criteria": "SKILL CRITERIA",
		"candidates": "CANDIDATES",
		"detailed_report": "DETAILED REPORT",
		"matches": "Matches",
		"filter_placeholder": "SELECT SKILLS",
		"list_placeholder_1": "TYPE YOUR DESIRED SKILL",
		"list_placeholder_2": "AND VIEW MATCHED CANDIDATES",
		"no_results": "No Candidates Found"
	},
	"buttons": {
		"search": "SEARCH"
	},
	"errors": {
		"login": {
			"email": "Email is mandatory",
			"password": "Password is mandatory"
		},
		"profile": {
			"passwordMismatch": "PASSWORDS MISMATCH",
			"passwordCriteria": "PASSWORD DOES NOT MATCH CRITERIA"
		},
		"academy": {
			"assessments_purchased": "Required"
		},
		"unexpected": "Unexpected error",
		"service_unavailable": "Service Unavailable",
		"requiredFields": "Required Fields"
	},
	"date": "DATE",
	"time": "TIME",
	"not_found": "Page not found",
	"not_allowed": "Not allowed"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/common/locale/en.json
// module id = 788
// module chunks = 0